import { Component } from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import actions from 'redux-form/lib/actions'
import _ from 'lodash'
import clx from 'classnames'
import { Button } from '@vzmi/shp_shared_compo'
import { FORM_ERROR_CLASS_NAME } from '../../../../../styles/variables'
import Tip from '../../../Common/Tip'
import {
  FORM_SECTION_NAME as TABLE_FORM_SECTION_NAME,
  getProductIdFromSelectedField,
  getSelectedProductIds
} from '../ModelTable'
import styles from './index.css'
import { UPDATE_LISTING_FORM_KEY } from '../../../../../constants/proposalTypes'
import { getTwoLayerInvalidProductIdsMap } from '../Modal/BatchRemove'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { PRODUCT_KEY } from '../constants'

const getErrorMsg = (tableRows, productIds, groupBySpecTableRows) => {
  if (_.isEmpty(productIds)) {
    return '請勾選欲移除之項目商品'
  }

  const twoLayerInvalidProductIdsMap = getTwoLayerInvalidProductIdsMap(
    productIds,
    tableRows,
    groupBySpecTableRows
  )
  if (!_.isEmpty(twoLayerInvalidProductIdsMap)) {
    const specName = _.get(tableRows, `0.${PRODUCT_KEY.SPEC_NAME}`)
    const invalidSpecString = _.join(_.keys(twoLayerInvalidProductIdsMap).slice(0, 3), `${COMMA} `)
    return `${specName} [${invalidSpecString}] 必須要有一個以上非隱藏狀態的商品`
  }

  return ''
}

class RemoveModeTableTip extends Component {
  onBatchRemoveConfirm = () => {
    const { onBatchRemove, tableValues } = this.props
    const selectedProductIds = getSelectedProductIds(tableValues)
    onBatchRemove(selectedProductIds)
  }

  onCancelRemoveMode = () => {
    const {
      toggleBatchRemoveMode,
      dispatch,
      tableValues
    } = this.props
    const checkboxFields = _.flow(
      () => _.keys(tableValues),
      fields => _.filter(fields, getProductIdFromSelectedField)
    )()
    const newTableValues = _.omit(tableValues, checkboxFields)
    dispatch(
      actions.change(UPDATE_LISTING_FORM_KEY, TABLE_FORM_SECTION_NAME, newTableValues)
    )
    toggleBatchRemoveMode()
  }

  render () {
    const {
      id,
      className,
      tableRows,
      groupBySpecTableRows,
      tableValues,
      batchRemoveMode,
      toggleBatchRemoveMode,
      onBatchRemoveModalOpen
    } = this.props
    const selectedProductIds = getSelectedProductIds(tableValues)
    const errorMsg = getErrorMsg(tableRows, selectedProductIds, groupBySpecTableRows)
    const isErrorMsgExist = !_.isEmpty(errorMsg)
    return (
      <>
        {
          batchRemoveMode && (
            <Tip
              id={id}
              className={clx(
                className,
                styles.tableTip,
                FORM_ERROR_CLASS_NAME
              )}
            >
              {isErrorMsgExist && (
                <span className={styles.tableTipErrorMsg}>
                  {errorMsg}
                </span>
              )}
            </Tip>
          )
        }
        <div className={styles.tableActions}>
          {
            !batchRemoveMode && (
              <Button
                data-role='batch-remove-mode-btn'
                onClick={toggleBatchRemoveMode}
                buttonType='outline'
                size='medium'
                fluid
              >
                批次移除項目
              </Button>
            )
          }
          {
            batchRemoveMode && (
              <>
                <Button
                  data-role='batch-remove-confirm-btn'
                  className={styles.batchRemoveConfirmBtn}
                  onClick={this.onBatchRemoveConfirm}
                  size='medium'
                  disabled={!_.isEmpty(errorMsg)}
                  fluid
                >
                  確認批次移除
                </Button>
                <Button
                  data-role='manual-batch-remove-btn'
                  className={styles.batchRemoveByIdBtn}
                  onClick={onBatchRemoveModalOpen}
                  buttonType='outline'
                  size='medium'
                  fluid
                >
                  自行輸入商品編號
                </Button>
                <Button
                  data-role='batch-remove-cancel-btn'
                  className={styles.batchRemoveModelCancelBtn}
                  onClick={this.onCancelRemoveMode}
                  buttonType='outline'
                  size='medium'
                  fluid
                >
                  取消批次移除
                </Button>
              </>
            )
          }
        </div>
      </>
    )
  }
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const RemoveModeTableTipWithReduxForm = connect(state => {
  return {
    tableValues: selector(state, TABLE_FORM_SECTION_NAME)
  }
})(RemoveModeTableTip)

export default RemoveModeTableTipWithReduxForm
